/*
===============================================================================
    File        =   ikimy-website-app/src/pages/Recruiter/DesktopRecruiter.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   Landing page for the Desktop Recruiter
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.03.12  Daniel Rashidian    Initial Creation
        -----------------------------------------------------------------------
===============================================================================
*/

import { Heroheaderemployer, EveryoneAgrees, SayGoodbye, NoCrystalBall, Validation } from "../../ui-components";
import { Flex, Image, Text, View } from "@aws-amplify/ui-react";
import RecruiterImageHero1 from "../../assets/images/home/RecruiterImageHero1.png"
import RecruiterImageHero2 from "../../assets/images/home/RecruiterImageHero2.png"
import SayGoodbyeImage from "../../assets/images/home/SayGoodByeImage.png"
import SayGoodbyeImage2 from "../../assets/images/home/SayGoodByeImage2.png"
import SayGoodbyeImage3 from "../../assets/images/home/SayGoodByeImage3.png"
import NoCrystalBallImage from "../../assets/images/home/NoCrystalBallImage.png"
import PartnerWithUsImage from "../../assets/images/home/PartnerWithUsImage.png"
import { useMediaQuery } from "react-responsive";
import { useMemo } from "react";

const RECRUITER_APP = process.env.REACT_APP_RECRUITER_APP;
const RHEALIZE_WEBSITE = process.env.REACT_APP_RHEALIZE_WEBSITE;

const DesktopRecruiter = ({

}) => {

    const crystallBallWidthBreakpoint = useMediaQuery({ query: '(min-width: 1254px)' })
    const isLargeScreen = useMediaQuery({ query: '(min-width: 1067px)' })

    const everyoneAgreesOverrides = useMemo(() => {
        return {
            EveryoneAgrees: {
                width: "100%",
                height: "100%"
            },
            "Frame 1160464790": {
                width: "100%",
                wrap: "wrap",
                justifyContent: "center",
                gap: "40px"
            },
            "Group 1160463944": {
            },
            "Frame 1160464104": {
                width: "unset",
                height: "100%",
                shrink: "1"
            },
            "Frame 1160464351": {
                width: "unset"
            },
            "This Is Job Search Done Right.": {
                width: "unset",
                shrink: "1"
            },
            "Frame 1160464105": {
                width: "unset"
            },
            Check753724223: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check753724227: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check753724231: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            "Line 3": {
                width: "unset"
            },
            "Line 2": {
                width: "unset"
            }
        };
    }, []);

    const sayGoodbyeOverrides = useMemo(() => {
        return {
            SayGoodbye: {
                width: "100%",
                padding: "71px 68px",
                wrap: "wrap-reverse",
                justifyContent: "center"
            },
            "Frame 1160464709": {
                width: "100%",
                shrink: "1",
                grow: "1",
                basis: "343px"
            },
            Title753724296: {
                width: "unset",
                height: "unset",
                display: "flex"
            },
            "Say Good-Bye to the Endless Drudgery of:": {
                width: "unset",
                position: "relative",
                shrink: "1"
            },
            "Managing The Submission Process": {
                shrink: "1"
            },
            "Stressful Resume Sorting": {
                shrink: "1",
                width: "unset"
            },
            "Corresponding With Those Who Don\u2019t Fit": {
                width: "unset",
                shrink: "1"
            },
            "Line 3753724305": {
                display: "none",
                width: "unset"
            },
            "Line 2753724312": {
                display: "none",
                width: "unset"
            },
            Title753724320: {
                width: "unset",
                height: "unset"
            },
            "Say Hello To:": {
                width: "unset",
                shrink: "1",
                position: "relative"
            },
            Check753724324: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            "Click - Sort - Done - SMILE!": {
                shrink: "1"
            },
            "Line 3753724326": {
                display: "none",
                width: "unset"
            },
            Check753724328: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            "Happier Candidates": {
                width: "unset",
                shrink: "1"
            },

            "Line 2753724330": {
                width: "unset",
                display: "none"
            },

            Check753724332: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            "Satisfying, Long-Term Results\u00A0": {
                width: "unset",
                shrink: "1",
            },
            Button: {
                width: "100%",
                style: {
                    cursor: "pointer"
                },
                onClick: (event) => {
                    window.open(`${RECRUITER_APP}`, "_blank");
                }
            },
            label: {
                shrink: "1"
            },
            "Frame 1160464791": {
                width: "100%",
                height: "100%",
                shrink: "1",
                grow: "1",
                basis: "377px",
                justifyContent: "center"

            },
            Image: {
                src: SayGoodbyeImage,
                objectFit: "contain",
                width: "unset",
                height: "unset"
            },
            Item: {
                position: "absolute",
                top: "50%",
                right: "0"
            },
            "image 18": {
                src: SayGoodbyeImage3,
                objectFit: "contain",
                width: "unset",
                height: "unset"
            },
            "image 19": {
                src: SayGoodbyeImage2,
                objectFit: "contain",
                width: "unset",
                height: "unset",
                top: "0",
                left: "0",
                position: "absolute"
            }
        };
    }, []);

    const noCrystalBallOverrides = useMemo(() => {
        return {
            NoCrystalBall: {
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "71px 68px",
                direction: "row",
                gap: "68px",
            },

            "Frame 1160464702": {
                width: "100%",
                position: "relative",
                display: "flex",
                top: "unset",
                bottom: "unset",
                left: "unset",
                order: "2"
            },
            Content: {
                width: "unset",
                height: "unset",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                direction: "column-reverse"
            },
            "The Info you Need.\u2028No Resume To Read.\u00A0": {
                width: "unset",
                position: "relative",
                shrink: "1",
                top: "unset",
                left: "unset"
            },
            Title: {
                width: "unset",
                height: "unset",
                position: "relative",
                display: "flex"
            },
            "No Crystal Ball Required.\u00A0": {
                position: "relative",
                shrink: "1"
            },
            "Only Top Qualifiers For Your Company\u00A0": {
                shrink: "1"
            },
            "Protect Your Corporate Culture\u00A0": {
                width: "unset",
                shrink: "1"
            },
            "Strong Candidates Create Strong Teams\u00A0": {
                width: "unset",
                shrink: "1"
            },
            "Line 3": {
                width: "unset",
                display: "none"
            },
            "Line 4": {
                width: "unset",
                display: "none"
            },
            "Line 5": {
                width: "unset",
                display: "none"
            },
            "Contributors - not Inhibitors.\u00A0": {
                width: "unset",
                height: "unset",
                shrink: "1"
            },

            Button: {
                style: {
                    cursor: "pointer"
                },
                onClick: (event) => {
                    window.open(`${RECRUITER_APP}`, "_blank");
                }
            },
            label753724396: {
                shrink: "1"
            },

            Elements: {
                width: "100%",
                height: "100%",
                position: "relative",
                top: "unset",
                left: "unset",
                right: "unset",
                bottom: "unset",
                order: "1",
                shrink: "1",
            },
            Image: {
                height: "unset",
                width: "unset",
                src: NoCrystalBallImage,
                objectFit: "contain",
            },
            "Group 1160463945": {
                top: "55%",
                left: crystallBallWidthBreakpoint ? "30%" : "5%",
                style: {
                    zIndex: "1"
                }
            },
            Check753724380: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check753724384: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check753724388: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check753724392: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.5923 19.553L6.37695 14.3364L8.11499 12.5984L11.5923 16.0745L18.5445 9.12109L20.2837 10.8604L11.5923 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.230469 14.2513C0.230469 6.78411 6.28411 0.730469 13.7513 0.730469C21.2185 0.730469 27.2721 6.78411 27.2721 14.2513C27.2721 21.7185 21.2185 27.7721 13.7513 27.7721C6.28411 27.7721 0.230469 21.7185 0.230469 14.2513ZM13.7513 25.3138C12.2986 25.3138 10.86 25.0277 9.51787 24.4717C8.1757 23.9158 6.95618 23.1009 5.92893 22.0737C4.90168 21.0464 4.08683 19.8269 3.53088 18.4847C2.97494 17.1426 2.6888 15.7041 2.6888 14.2513C2.6888 12.7986 2.97494 11.36 3.53088 10.0179C4.08683 8.6757 4.90168 7.45618 5.92893 6.42893C6.95618 5.40168 8.1757 4.58683 9.51787 4.03088C10.86 3.47494 12.2986 3.1888 13.7513 3.1888C16.6853 3.1888 19.499 4.35431 21.5737 6.42893C23.6483 8.50355 24.8138 11.3173 24.8138 14.2513C24.8138 17.1853 23.6483 19.999 21.5737 22.0737C19.499 24.1483 16.6853 25.3138 13.7513 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            "substep/completed753724460": {
                padding: "2.627px 5.254px",
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                style: {
                    borderRadius: "39.405px",
                    background: "#47A050"
                },
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
                        <path d="M6.58325 0.561138C6.76112 0.725327 6.76112 1.01266 6.58325 1.17685L3.08054 4.67955C2.91635 4.85742 2.62902 4.85742 2.46483 4.67955L0.713482 2.9282C0.53561 2.76401 0.53561 2.47668 0.713482 2.31249C0.877671 2.13462 1.165 2.13462 1.32919 2.31249L2.76585 3.74915L5.96754 0.561138C6.13173 0.383266 6.41906 0.383266 6.58325 0.561138Z" fill="white" />
                    </svg>
                )
            },
            "substep/completed753724466": {
                padding: "2.627px 5.254px",
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                style: {
                    borderRadius: "39.405px",
                    background: "#47A050"
                },
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
                        <path d="M6.58325 0.285747C6.76112 0.449937 6.76112 0.737268 6.58325 0.901457L3.08054 4.40416C2.91635 4.58203 2.62902 4.58203 2.46483 4.40416L0.713482 2.65281C0.53561 2.48862 0.53561 2.20129 0.713482 2.0371C0.877671 1.85923 1.165 1.85923 1.32919 2.0371L2.76585 3.47375L5.96754 0.285747C6.13173 0.107876 6.41906 0.107876 6.58325 0.285747Z" fill="white" />
                    </svg>
                )
            },
            SubStepNumber753724472: {
                padding: "2.627px 5.254px",
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                style: {
                    borderRadius: "39.405px",
                    background: "var(--colors-blue-80, #043495)"
                },
                children: (
                    <Text
                        color="#FFF"
                        fontFamily="Inter"
                        fontSize="7.005px"
                        fontStyle="normal"
                        fontWeight="400"
                        lineHeight="normal"
                        children="3"
                    ></Text>
                )
            },
            SubStepNumber753724478: {
                padding: "2.627px 5.254px",
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                style: {
                    borderRadius: "39.405px",
                    background: "var(--colors-blue-80, #043495)"
                },
                children: (
                    <Text
                        color="#FFF"
                        fontFamily="Inter"
                        fontSize="7.005px"
                        fontStyle="normal"
                        fontWeight="400"
                        lineHeight="normal"
                        children="4"
                    ></Text>
                )
            },
            AccordionChevron753724464: {
                display: "flex",
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                        <path d="M10.043 0.867863L9.26042 -0.00781253L5.49228 3.75212L1.72413 -0.00781286L0.848373 0.867863L5.44567 5.46516L10.043 0.867863Z" fill="#2D3F5C" />
                    </svg>
                )
            },
            AccordionChevron753724470: {
                display: "flex",
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                        <path d="M10.043 0.867863L9.26042 -0.00781253L5.49228 3.75212L1.72413 -0.00781286L0.848373 0.867863L5.44567 5.46516L10.043 0.867863Z" fill="#2D3F5C" />
                    </svg>
                )
            },
            AccordionChevron753724476: {
                display: "flex",
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                        <path d="M10.043 0.867863L9.26042 -0.00781253L5.49228 3.75212L1.72413 -0.00781286L0.848373 0.867863L5.44567 5.46516L10.043 0.867863Z" fill="#2D3F5C" />
                    </svg>
                )
            },
            AccordionChevron753724482: {
                display: "flex",
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                        <path d="M10.043 0.867863L9.26042 -0.00781253L5.49228 3.75212L1.72413 -0.00781286L0.848373 0.867863L5.44567 5.46516L10.043 0.867863Z" fill="#2D3F5C" />
                    </svg>
                )
            },

            "Line 9": {
                width: "28px",
                height: "8px"
            },
            "Line 10": {
                height: "16px"
            },
            "Line 11": {
                height: "18px"
            },

        };
    }, [crystallBallWidthBreakpoint]);

    const validationOverrides = useMemo(() => {
        return {
            Validation: {
                width: "100%",
                height: "100%",
                padding: "71px 68px"
            },

            "Truth From Those Who Know\u00A0": {
                shrink: "1"
            },
            Testimonials: {
                width: "unset",
                height: "unset",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start"
            },
            Content: {
                width: "unset",
                position: "relative",
                top: "unset",
                left: "unset"
            },
            "8": {
                height: "unset",
                transform: "rotate(-90deg)"
            },
            "By using Ikimy's standardized recruitment process, employers can improve their ability to select candidates who are well-suited for their roles by\u00A045%* or more - enhancing overall organizational performance and employee retention.": {
                shrink: "1"
            },
            "(International Journal of Social Science And Human Research, 2023)": {
                shrink: "1"
            }
        };
    }, []);

    return (
        <>
            <Flex
                width="100vw"
                //  height="100vh"
                style={{
                    background: "#102641"
                }}
                justifyContent="center"
                padding="30px 60px 0px 60px"
                position="relative"
            >
                <Flex
                    display="inline-flex"
                    width="100%"
                    height="100%"
                    padding="11.731px"
                    alignItems="flex-start"
                    gap="11.731px"
                    shrink="1"
                    alignSelf="flex-end"
                >
                    <Image
                        background={`lightgray 50% / cover no-repeat`}
                        src={RecruiterImageHero1}
                        objectFit="contain"
                    />
                </Flex>
                <Heroheaderemployer
                    overrides={{
                        Heroheaderemployer: {
                            width: "100%",
                            shrink: "1",
                            ...(!isLargeScreen) && {
                                position: "absolute",
                                top: "0",
                                bottom: "0",
                                width: "100%",
                                backgroundColor: "rgb(16 38 65 / 45%)",
                                style: {
                                }
                            }
                        },
                        "Jobs Made Simple. Uniting Employers With Top Candidates\u00A0": {
                            shrink: "1",
                            children: (
                                <>
                                    <span>
                                        Jobs Made Simple.
                                    </span>
                                    <br></br>
                                    <span
                                        style={{
                                            fontSize: "32px",
                                            fontStyle: "normal",
                                            fontWeight: "400",
                                            lineHeight: "141.523%"
                                        }}

                                    >
                                        Uniting Employers With Top Candidates
                                    </span>

                                </>

                            )
                        },
                        Button: {
                            style: {
                                cursor: "pointer"
                            },
                            onClick: (event) => {
                                window.open(`${RECRUITER_APP}`, "_blank");
                            }
                        }
                    }}
                ></Heroheaderemployer>
                <Flex
                    display="inline-flex"
                    width="100%"
                    height="100%"
                    padding="11.731px"
                    alignItems="flex-start"
                    gap="11.731px"
                    shrink="1"
                    alignSelf="flex-end"
                >
                    <Image
                        background={`lightgray 50% / cover no-repeat`}
                        src={RecruiterImageHero2}
                        objectFit="contain"
                    />
                </Flex>
                <Flex

                ></Flex>
            </Flex>
            <EveryoneAgrees overrides={everyoneAgreesOverrides}></EveryoneAgrees>
            <SayGoodbye overrides={sayGoodbyeOverrides}></SayGoodbye>
            <NoCrystalBall overrides={noCrystalBallOverrides}></NoCrystalBall>
            <Validation overrides={validationOverrides}></Validation>
            <Flex
                gap="132px"
                direction="row"
                width="100%"
                height="100%"
                justifyContent="flex-start"
                alignItems="center"
                overflow="hidden"
                position="relative"
                borderRadius="8px"
                padding="0px 0px 0px 0px"
                backgroundColor="rgba(251,245,231,1)"
            >
                <View
                    width="100%"
                    height="100%"
                    display="flex"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    shrink="1"
                    grow="1"
                    basis="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    children={(
                        <Image
                            src={PartnerWithUsImage}
                            objectFit="contain"
                        ></Image>
                    )}
                ></View>
                <Flex
                    gap="32px"
                    direction="column"
                    width="100%"
                    height="unset"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    shrink="1"
                    grow="1"
                    basis="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                >
                    <Text
                        fontFamily="Inter"
                        fontSize="32px"
                        fontWeight="400"
                        color="rgba(0,0,0,1)"
                        lineHeight="38.727272033691406px"
                        textAlign="left"
                        display="block"
                        direction="column"
                        justifyContent="unset"
                        width="unset"
                        height="unset"
                        gap="unset"
                        alignItems="unset"
                        shrink="1"
                        alignSelf="stretch"
                        position="relative"
                        padding="0px 0px 0px 0px"
                        whiteSpace="pre-wrap"
                        children={(
                            <>
                                <span
                                    style={{
                                        color: "#0B141F",
                                        fontFamily: "Inter",
                                        fontSize: "40px",
                                        fontStyle: "normal",
                                        fontWeight: "700",
                                        lineHeight: "normal"
                                    }}
                                >
                                    Partner with Us
                                </span>
                                <br></br>
                                <span
                                    style={{
                                        color: "#000",
                                        fontFamily: "Inter",
                                        fontSize: "20px",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "150%"
                                    }}

                                >
                                    Make The Smart Move Today.
                                </span>
                                <br></br>
                                <span
                                    style={{
                                        color: "#000",
                                        fontFamily: "Inter",
                                        fontSize: "20px",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "150%"
                                    }}

                                >
                                    Discover Why ikimy Works.
                                </span>
                            </>

                        )}

                    ></Text>
                    <Flex
                        gap="0"
                        direction="row"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        shrink="0"
                        position="relative"
                        borderRadius="4px"
                        padding="16px 24px 16px 24px"
                        backgroundColor="rgba(204,164,59,1)"
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={(event) => {
                            window.open(`${RHEALIZE_WEBSITE}`, "_blank")
                        }
                        }
                    >
                        <Text
                            fontFamily="Inter"
                            fontSize="16px"
                            fontWeight="700"
                            color="rgba(255,255,255,1)"
                            lineHeight="24px"
                            textAlign="left"
                            display="block"
                            direction="column"
                            justifyContent="unset"
                            width="unset"
                            height="unset"
                            gap="unset"
                            alignItems="unset"
                            shrink="0"
                            position="relative"
                            padding="0px 0px 0px 0px"
                            whiteSpace="pre-wrap"
                            children="Start Hiring with Rhealize"
                        ></Text>
                    </Flex>
                </Flex>
            </Flex>
        </>
    )

};

export default DesktopRecruiter;